import { GameState, GameStateEnum } from "../fondue";

// Load background image
const backgroundImg = new Image();
backgroundImg.src = '/fondue.png';

const fondPot = new Image();
fondPot.src = '/fond_caquelon.png';

const cheeseImg = new Image();
cheeseImg.src = '/fromage.png';

const loadingPomise = Promise.all([
    new Promise(resolve => backgroundImg.onload = resolve),
    new Promise(resolve => fondPot.onload = resolve),
    new Promise(resolve => cheeseImg.onload = resolve),
]);

export interface AnimationContext {
    lastTime: number, 
    ctx: CanvasRenderingContext2D, 
    gameState: GameState,
    stop: boolean,
    setWarning: (newValue: string) => void, 
    zoom: number
    onGameEnd: () => void,
}


// Animation loop
export const getAnimationFunction = (context: AnimationContext) => {
    const animationFunction = async () => {
        await loadingPomise;

        const {lastTime, ctx, gameState, stop, setWarning, zoom, onGameEnd} = context;
        const canvas = ctx.canvas;

        const now = Date.now();
        const deltaTime = now - lastTime;
        context.lastTime = now;

        // Clear canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        if (!stop && gameState.gameState !== GameStateEnum.notStarted && gameState.gameState !== GameStateEnum.scores) {
            gameState.cheeseLevel -= deltaTime / 1000;
            if (gameState.cheeseLevel <= 45) {
                setWarning("C'est bientôt la fin !");
            }
            if (gameState.cheeseLevel <= 35) {
                context.stop = true;
                onGameEnd();
            }
        }

        if (backgroundImg.complete && fondPot.complete) {
            // Draw background
            ctx.drawImage(
                fondPot,
                0, 0, // source x, y
                fondPot.width, fondPot.height, // source width, height
                zoom * 207, zoom * 135, // destination x, y
                zoom * fondPot.width, zoom * fondPot.height // destination width, height
            );
            ctx.drawImage(
                cheeseImg,
                0, 0, // source x, y
                cheeseImg.width, cheeseImg.height, // source width, height
                zoom * 220, zoom * (155 + (100 - gameState.cheeseLevel)), // destination x, y
                zoom * cheeseImg.width, zoom * cheeseImg.height // destination width, height
            );

            ctx.drawImage(backgroundImg, 0, 0, zoom * backgroundImg.width, zoom * backgroundImg.height);

            // Draw picAFondue
            gameState.picAFondue.draw(deltaTime, ctx, zoom);

            // Draw cheese to mask the bread
            const cheeseMask = 60 - (gameState.picAFondue.centerY - gameState.picAFondue.pos.y + (100 - gameState.cheeseLevel)) + 100*Math.sin(gameState.picAFondue.pos.r);
            ctx.drawImage(
                cheeseImg,
                0, cheeseMask, // source x, y
                cheeseImg.width, cheeseImg.height - cheeseMask, // source width, height
                zoom * 220, zoom * (155 + cheeseMask + (100 - gameState.cheeseLevel)), // destination x, y
                zoom * cheeseImg.width, zoom * (cheeseImg.height - cheeseMask) // destination width, height
            );

            // Draw bottom of the pot again
            ctx.drawImage(
                backgroundImg,
                0, 210, // source x, y
                backgroundImg.width, (backgroundImg.height - 210), // source width, height
                0, zoom * 210, // destination x, y
                zoom * backgroundImg.width, zoom * (backgroundImg.height - 210) // destination width, height
            );

            // draw scores
            gameState.picAFondue.drawScores(ctx, zoom, gameState.scores);
        }

        if (gameState.gameState !== GameStateEnum.scores) {
            requestAnimationFrame(animationFunction);
        }
    }

    return animationFunction;
};